module.exports = __webpack_public_path__ + "static/media/999.aa3f2e42.png";